import { render, staticRenderFns } from "./MyPageCancelFix.vue?vue&type=template&id=23c8c3c6&"
import script from "./MyPageCancelFix.vue?vue&type=script&lang=js&"
export * from "./MyPageCancelFix.vue?vue&type=script&lang=js&"
import style0 from "./MyPageCancelFix.vue?vue&type=style&index=0&id=23c8c3c6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports